var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"theme-color",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('Default',{staticClass:"dialog mb-sm-5",class:{ xs: _vm.$vuetify.breakpoint.xsOnly },attrs:{"accident":_vm.accident || ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }